export enum CollectionPaymentTypes{
    EXPORT_RECEIVABLES = 'EXPORT RECEIVABLES',
    DUTY_DRAW_BACK= 'DUTY DRAW BACK',
    RODTEP ='RODTEP',
    IGST = 'IGST'
}
export enum IceGateStatus{
    VERIFIED='VERIFIED',
    NOT_VERIFIED = 'NOT VERIFIED',
    UPDATE = 'UPDATE',
    NOT_UPDATE= 'NOT UPDATE',
}
export enum BrcStatus{
    PARTIAL_UPDATE = 'PARTIAL UPDATE',
    FULL_UPDATE = 'FULL UPDATE',
    NOT_UPDATE= 'NOT UPDATE',
}
export enum RodtepStatus{
    PAYMENT_NOT_RECEIVED_AND_ICE_GATE_NOT_UPDATED = 'PAYMENT NOT RECEIVED AND ICE GATE NOT UPDATED',
    PAYMENT_NOT_RECEIVED_AND_ICE_GATE_UPDATED = 'PAYMENT NOT RECEIVED AND ICE GATE UPDATED',
    PAYMENT_RECEIVED_AND_ICE_GATE_UPDATED = 'PAYMENT RECEIVED AND ICE GATE UPDATED',
    PAYMENT_RECEIVED_AND_BRC_UPDATED = 'PAYMENT RECEIVED AND BRC UPDATED',
    PAYMENT_RECEIVED_AND_PARTIAL_BRC_UPDATED = 'PAYMENT RECEIVED AND PARTIAL BRC UPDATED',
    READY_FOR_SCRIPT_GENERATION = 'READY FOR SCRIPT GENERATION',
    READY_FOR_SALE = 'READY FOR SALE',
    SOLD = 'SOLD',  
    RECEIVED= 'RECEIVED'

}